module.exports = __webpack_public_path__ + "img/v2.331bd60e.png";